import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';

const featureBreadcrumb = [
  {
    text: 'Dashboard',
    disabled: false,
    to: 'dashboard',
  },
  {
    text: 'CardMais',
    disabled: false,
    to: 'contacard.submodules.list',
  },
  {
    text: 'Listar conciliações',
    disabled: false,
    to: 'conciliation.list',
  },
];

export default [
  ...buildCrudRoutes({
    baseName: 'conciliation',
    basePath: 'conciliacao-transferencia',
    card: {
      title: 'Conciliação de transferências',
      icon: 'home',
    },
    baseBreadcrumbs: featureBreadcrumb,
    moduleActive: 'contacard',
    subModuleActive: 'conciliations',
    listRoute: {
      pageContent: () => import('Modules/contacard/conciliations/transfer/conciliation/ConciliationCrudList.vue'),
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
      filterComponent: () => import('Modules/contacard/conciliations/transfer/conciliation/components/ConciliationTransferFilter.vue'),
      speedFilter: () => import('Modules/contacard/conciliations/transfer/conciliation/components/ConciliationSpeedFilter.vue'),
      pageTitle: 'Conciliação de transferências',
      navigateBackRoute: 'contacard.submodules.list',
      searchOptions: { label: 'Buscar conciliação', searchAttribute: 'search' },
    },
    editRoute: {
      component: () => import('Modules/contacard/conciliations/transfer/conciliation/ConciliationEditPage.vue'),
      breadcrumbs: [
        {
          text: 'Visualizar sugestões',
          disabled: true,
        },
      ],
    },
  }),
];
